<template>
  <v-row>
    <v-col cols="12">
      <v-sheet
        v-if="!loading"
        outlined>
        <v-col class="pa-4 mb-8">
          <v-lazy
            :options="{
              threshold: .5
            }"
            min-height="200"
            transition="fade-transition">

              <showIdeaProjectsStand 
              v-if="!loading && entrepreneurship.window.type_postulations_id===1"
              :data="entrepreneurship"
              :logo="customization.idea_project_logo"
              :color="customization.idea_project_color"
              :project_gallery_mode="customization.project_gallery_mode"/>
    
            <showIdeaProjectsSchoolsStand 
              v-if="!loading && entrepreneurship.window.type_postulations_id===2" 
              :data="entrepreneurship"
              :logo="customization.idea_project_school_logo"
              :color="customization.idea_project_school_color"
              :project_gallery_mode="customization.project_gallery_mode"/>
                  
            <showBusinessModelsStand
              v-if="!loading && entrepreneurship.window.type_postulations_id===3"
              :data="entrepreneurship" 
              :logo="customization.business_model_logo"
              :color="customization.business_model_color"
              :project_gallery_mode="customization.project_gallery_mode"/>

          </v-lazy>
        </v-col>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="d-sm-flex">
      <v-btn
        depressed
        color="primary"
        :block="$vuetify.breakpoint.xsOnly"
        class="mr-auto mt-2"
        :to="{ name: 'windowsAdmin'}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>
      
      <v-spacer />

      <v-btn
        depressed
        color="primary"
        :block="$vuetify.breakpoint.xsOnly"
        class="mr-2 mt-2"
        :to="{ name: 'editWindowAdmin'}"
        >
        <v-icon left>
          mdi-pencil
        </v-icon>
        Editar
      </v-btn>

      <v-btn
        depressed
        :block="$vuetify.breakpoint.xsOnly"
        class="mr-2 mt-2"
        color="primary"
        :loading="loading_download"
        @click="downloadWindowPDF">
        Descargar PDF
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
      >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  import download from 'downloadjs'
  const VUE_URL_API = process.env.VUE_APP_URL_API

  import showIdeaProjectsStand from '@/components/stand/preview/showIdeaProjectsStandPreview.vue'
  import showIdeaProjectsSchoolsStand from '@/components/stand/preview/showIdeaProjectsSchoolsStandPreview.vue'
  import showBusinessModelsStand from '@/components/stand/preview/showBusinessModelsStandPreview.vue'

  export default {
    name: 'showWindowAdmin',
    components: { 
      showIdeaProjectsStand,
      showIdeaProjectsSchoolsStand,
      showBusinessModelsStand},
    data: () => ({
      loading:true,
      loading_download: false,
      entrepreneurship_id:null,
      edition_id: null,
      entrepreneurship:[],
      customization: []
    }),

    methods:{
      async loadAllData() {
        this.loading = true;
        try {
          await this.getWindowAdmin()
          await this.getCustomizationProjectGallery()
        } catch (error) {
          console.error(error)
        } finally {
          this.loading = false
        }
      },

      async getWindowAdmin() {
        const response = await axios.get(
          `admin/entrepreneurships/${this.entrepreneurship_id}/show-window`
        )
        this.entrepreneurship = response.data.data
        this.edition_id = this.entrepreneurship.window.edition_id
        // deshabilito el click para dar like/dislike
        this.entrepreneurship.window.handle_like = false
      },

      async getCustomizationProjectGallery() {
        const url = `admin/editions/${this.edition_id}/customization`
        const response = await axios.get(url)
        this.customization = response.data.data.customization
      },

      async downloadWindowPDF(){
        this.loading_download=true
        let url = VUE_URL_API + '/admin/windows/'+this.entrepreneurship_id+'/generate-pdf'

        await axios.get(
          url, 
          {responseType: 'blob'}
        ).then((response) => {
          //window.open(URL.createObjectURL(response.data));
          const content = response.headers['content-type'];
          download(response.data, 'stand' , content)
          this.loading_download=false
        })
      }
    },

    created(){
       this.entrepreneurship_id = this.$route.params.entrepreneurship_id;
       this.loadAllData()
    },
  }
</script>
<style>
.images {
  position: fixed;
}
</style>